import { call, put, select, takeEvery } from "redux-saga/effects";
import { pwaSlice } from "./pwaReducer";
import { getPwaInstallPromptEventSelector } from "./pwaSelectors";
import { IPwaInstallPromptEvent, IPwaInstallPromptResult } from "./pwa.t";
import { logAction, logAppsflyerAction } from "../../app/appActions";
import { LOG_AF_EVENT_NAMES } from "../../app/appConstants";
import ExponeaNotifications from "../Exponea/ExponeaNotifications";
import { TExponeaSdkNotificationsSubscribeStatus } from "../Exponea/exponea.t";
import { isClientSafari } from "../../components/ClientInfo/ClientInfo";
import { openMobileSliderPageAction } from "../../mobileAppCore/mobileAppActions";
import { MOBILE_SLIDER_PAGES_IDS } from "../../mobileAppCore/components/MobileSliderPages/mobileSliderPagesConstants";

function openPwaPromptPromise(installPromptEvent: IPwaInstallPromptEvent): Promise<IPwaInstallPromptResult> {
    return new Promise((resolve) => {
        installPromptEvent.prompt();
        installPromptEvent.userChoice.then((result: IPwaInstallPromptResult) => {
            resolve(result);
        });
    });
}

function* openPwaInstallPromptSaga() {
    let outcome: 'accepted' | 'dismissed' | 'pwa-ios-instruction' | undefined;
    if (isClientSafari) {
        yield put(openMobileSliderPageAction(MOBILE_SLIDER_PAGES_IDS.PWA_IOS_INSTRUCTION));
        outcome = 'pwa-ios-instruction';
    } else {
        const installPromptEvent: IPwaInstallPromptEvent | null = yield select(getPwaInstallPromptEventSelector);
        if (!installPromptEvent) return;
        const result: IPwaInstallPromptResult = yield call(openPwaPromptPromise, installPromptEvent);
        outcome = result.outcome;
    }

    yield put(logAppsflyerAction({
        name: LOG_AF_EVENT_NAMES.PWA_PROMPT,
        payload: {
            outcome: outcome,
            referer: window.location.href,
        },
    }));
    yield put(logAction({
        operation: 'pwa_prompt',
        outcome: outcome,
        referer: window.location.href,
    }));
}

function* initPwaWebPushNotificationsSaga() {
    const exponeaNotifications = new ExponeaNotifications();
    let isAvailable = yield call(exponeaNotifications.isAvailable);
    let currentSubscription: { active: boolean, denied: boolean } = yield call(exponeaNotifications.isSubscribed);
    let subscribePromptStatus: TExponeaSdkNotificationsSubscribeStatus | null = null;

    if (isAvailable && !currentSubscription.active && !currentSubscription.denied) {
        subscribePromptStatus = yield call(exponeaNotifications.subscribe);
        currentSubscription = yield call(exponeaNotifications.isSubscribed);
    }

    yield put(logAction({
        available: isAvailable,
        active: currentSubscription.active,
        denied: currentSubscription.denied,
        subscribePromptStatus,
        operation: 'pwa_web_push_notifications_init',
    }));
}

export function* pwaSagas() {
    yield takeEvery(pwaSlice.actions.openPwaInstallPromptAction, openPwaInstallPromptSaga);
    yield takeEvery(pwaSlice.actions.initPwaWebPushNotificationsAction, initPwaWebPushNotificationsSaga)
}
